// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"fa6c9596","845":"0b1d9514"}[chunkId] + ".chunk.js";
};